// extracted by mini-css-extract-plugin
export default {"hoursList":"ServicePeriods-module__hoursList___2V0c3"};